import axios from 'axios'


const client = axios.create();

export const apiUrl = process.env.REACT_APP_MAIN_DOMAIN

export function Login(inputs) {
    return client.post(
        `${apiUrl}/login`, inputs
    )
}

export function ResetPasswordSend(inputs) {
    return client.post(
        `${apiUrl}/password/email`, inputs
    )
}

export function RegisterStepOne(inputs) {
    return client.post(
        `${apiUrl}/register/step_one`, inputs
    )
}

export function RegisterStepTwo(inputs) {
    return client.post(
        `${apiUrl}/register/step_two`, inputs
    )
}

export function RegisterEmailVerify(inputs) {
    return client.post(
        `${apiUrl}/register/email-verify`, inputs
    )
}

export function RegisterResendEmail(inputs) {
    return client.post(
        `${apiUrl}/resend-code`, inputs
    )
}

export function resetPassword(inputs) {
    return client.post(
        `${apiUrl}/password/reset`, inputs
    )
}